
<template>
  <!--产品列表-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="product_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_t" slot-scope="{row}">
        <a-tooltip placement="topLeft" :title="row.category_full_name">
          <span :style="{cursor: 'pointer'}">{{row.category_title}}</span>
        </a-tooltip>
      </template>
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'product',
  data () {
    return {
      searchList: [
        { props: ['keywords'], placeholder: '产品名称、型号', options: [], inputType: 'input' },
        { props: ['status'], placeholder: '状态', options: this.$store.state.statusList, inputType: 'select' },
        { props: ['create_date'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', key: 'addbtn' }
      ],
      rowOptList: [
        { text: '修改', handle: (row) => this.$children[0].toEdit(row), key: 'edit' },
        { text: '编辑功能', handle: (row) => this.toEditFun(row.product_id), key: 'editFun' },
        { text: '初始化设备', handle: (row) => this.initProduct(row.product_id), key: 'init' },
        [
          { text: '删除', handle: (row) => this.$children[0].showDeleteConfirm(row), key: 'delete' }
        ]
      ],
      columns: [
        { title: 'ID', dataIndex: 'product_id', align: 'left', width: '' },
        { title: '产品名称', dataIndex: 'title', align: 'left', width: '' },
        { title: '产品型号', dataIndex: 'type', align: 'left', width: '' },
        { title: '所属分类', dataIndex: 'category_title', align: 'left', width: '', scopedSlots: {customRender: 'action_t'} },
        { title: '备注', dataIndex: 'description', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '状态', dataIndex: 'status_desc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        keywords: '',
        status: '',
        category_id: '',
        create_date: ''
      },
      listApi: {
        url: '/product',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addProduct',
        title: '修改产品'
      },
      deleteParam: {
        url: '/product',
        param: {pk_key: 'product_id', pk_val: ''},
        title: '产品',
        key: 'title'
      }
    };
  },
  created () {
  },
  methods: {
    /* 初始化产品 */
    initProduct (id) {
      this.$confirm({
        title: '确定要初始化设备？',
        centered: true,
        onOk: () => {
          if (Array.isArray(id)) {
            id = id.join(',');
          }
          this.$post({
            url: '/product/action/reset',
            params: { product_id: id }
          }).then((res) => {
            this.$message.success('初始化成功！');
          });
        }
      });
    },
    /* 编辑功能 */
    toEditFun (id) {
      this.$router.push({
        name: 'editProduct',
        query: { id: id }
      });
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/device/product/product.vue